import { render, staticRenderFns } from "./AddMembership.vue?vue&type=template&id=0b71bc9f"
import script from "./AddMembership.vue?vue&type=script&lang=js"
export * from "./AddMembership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports